import React from "react";

import GraphqlWrapper from "GraphQL/GraphqlWrapper";
import GridPropsQuery from "../lib/AgGrid/GridPropsQuery";

import Table from "./Table";

const NetworkPartnersApp = props => {
  return (
    <GraphqlWrapper>
      <GridPropsQuery
        render={({ contractCodes, currentUser }) => (
          <section className="network_partner_section">
            <Table contractCodes={contractCodes} currentUser={currentUser} />
          </section>
        )}
      />
    </GraphqlWrapper>
  );
};

export default NetworkPartnersApp;
